import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import './About.scss'

class About extends Component {
    exit = () => {
        this.props.onClose()
    }

    render() {
        const { t } = this.props
        return (
        <div className="about">
            <div className="about-header">
                <div className="about-title">
                    Om GeoEiendom
                </div>
                <div className="close-button" onClick={this.exit}>
                    <span className=""><i className={"fa fa-times fa-fw"}></i></span>
                    <span>{t('lukk')}</span>
                </div>
            </div>
            
            <div className="about-content">
                <div className="content-section">
                    <img className="about-image-right" style={{height:'240px'}} src="images/about_application.gif" />
                    <p>
                        GeoEiendom gir deg alt av eiendomsinformasjon fra Matrikkelen og Grunnboken samlet på ett sted.
                    </p>
                    <p>
                        Matrikkelen er Norges offisielle register over fast eiendom, herunder bygninger, boliger og adresser. 
                        Grunnboken er et offentlig register over tinglyste rettigheter og heftelser i fast eiendom og borettslagsandeler. 
                    </p>
                    <p>
                        GeoEiendom er utviklet av Geodata AS, og grunnbokopplysninger kommer fra Ambita AS.
                    </p>
                    <p>
                        I denne løsningen kan du:
                    </p>
                    <ul>
                        <li>Søke etter eiendommer, eiere, adresser, stedsnavn og mer</li>
                        <li>Velge eiendommer, adresser og bygg i kartet for å se detaljert informasjon</li>
                        <li>Utforske alt av matrikkel- og grunnbokinformasjon for eiendommen du har valgt</li>
                        <li>Hente ut rapporter, slik som eiendomsrapport, grunnbokrapport osv.</li>
                        <li>Bestille bekreftede grunnbokrapporter eller tinglyste dokumenter</li>
                    </ul>
                </div>                
                <div className="content-section">
                    <div className="section-title">Søke etter informasjon</div>
                    <img className="about-image-right" style={{height:'160px'}} src="images/about_search_results.png" />
                    <p>
                        I søkefeltet øverst til venstre skriver du inn det du ønsker å søke etter, og resultatene vises fortløpende etter hvert som du skriver i søkefeltet.
                    </p>
                    <p>
                        Eksempler på søk:
                    </p>
                    <ul>
                        <li>Eiendom - "Hurum 44/52", "628-44/52" eller "628 44/52"</li>
                        <li>Adresse - "Bryggen 7" eller "Bryggen 7 Bergen"</li>
                        <li>Eier - "Ola Normann", "Ola Normann Oslo" eller "Norsk Hydro ASA"</li>
                        <li>Bygningsnummer - "139323505"</li>
                        <li>Stedsnavn - "Galdhøpiggen" eller "Trondheim"</li>
                    </ul>
                </div>
                <div className="content-section" id="about_mapnavigation">
                    <div className="section-title">Bevege seg rundt i kartet</div>
                    <p>
                        Den enklest måten å bevege seg rundt i kartet på er å holde venstre museknapp nede for å dra kartet i ønsket retning,
                        og bruke +/- knappene øverst til høyre i kartet for å zoome inn og ut. 
                    </p>
                    <p>
                        Andre mer avanserte muligheter:
                    </p>
                    <ul>
                        <li>Bruk tastaturet - piltastene for å gå en retning, og +/- for å zoome inn/ut</li>
                        <li>Dobbelt-klikke for å zoome inn</li>
                        <li>Holde Shift-knappen nede og klikke og dra en firkant i kartet for å zoome til dette området</li>
                        <li>Bruke rullemus el.l. for å zoome inn eller ut</li>
                    </ul>
                </div>                
                <div className="content-section">
                    <div className="section-title">Velge i kartet</div>
                    <img className="about-image-right" style={{height:'110px'}} src="images/about_map_popup.png" />
                    <p>
                        Klikk i kartet med venstre museknapp for å få opp en pop-up med informasjon om eventuelle eiendommer, adresser eller bygg du har søkt på. 
                        Denne boksen (bildet til høyre), viser noen få egenskaper, og du kan bruke pil-tastene for å bla mellom de ulike treffene. 
                        Om du klikker "Velg..." nederst til venstre i boksen, blir dette objektet fra matrikkelen valgt og du kan nå se detaljert matrikkel- og grunnbokinformasjon.
                    </p>
                 </div>
                <div className="content-section">
                    <div className="section-title">Se matrikkelinformasjon</div>
                    <p>
                        Etter at du har søkt eller valgt i kartet, kan du se mer detaljert informasjon i vinduet til venstre. 
                        Øverst ser du informasjon om det du har valgt, og under ser du lister med relatert informasjon til søket eller valget ditt. 
                        Hva som vises vil avhenge av hva du har valgt. 
                        Følgende kan velges, og dermed være øverste nivå i listen: Eiendom (grunneiendom, feste, seksjon, jordsameie, anleggseiendom, annen matrikkelenhet), adresse, bygning eller eier.
                    </p>
                    <img className="about-image-right" style={{height:'70px'}} src="images/about_goto.png" />
                    <p>
                        Klikk på listen for å vise alle elementene. For å se alle egenskapene må du klikke på et element i listen. 
                        For elementer av typene nevnt over, finnes det to snarveier tilgjengelig (se bildet til høyre): 
                        Du kan klikke på kart-ikonet for å vise teigen, adressen, bygget, osv. i kartet. 
                        I tillegg kan du klikke på pil-ikonet for å velge dette elementet til øverste nivå i listen. 
                        Dermed kan du f.eks. se relatert informasjon knyttet til en eier, adresse osv.
                    </p>
                </div>
                <div className="content-section">
                    <div className="section-title">Se grunnbokinformasjon</div>
                    <img className="about-image-right" style={{height:'70px'}} src="images/about_grunnbok.png" />
                    <p>
                        Når du har valgt en eiendom, vil du få en egen bolk øverst i listen som heter "Grunnbok". 
                        Her har du en del snarveier for å hente ut ulike rapporter (se bildet til høyre). 
                        Om du utvider grunnbok-listen, vises all informasjon som kan hentes ut fra Grunnboken. 
                        Her kan du se servitutter, heftelser, hjemmelsopplysninger, osv. 
                        Du kan også bestille tinglyste dokumenter og bekreftet grunnbok. 
                        Dette er dokumenter som sendes som brev fra Kartverket, og har en særskilt kostnad (oppgitt i bestillingsvinduet).
                    </p>
                </div>
                <div className="content-section">
                    <div className="section-title">Annen kartfunksjonalitet</div>
                    <img className="about-image-right" style={{height:'150px'}} src="images/about_map_tools.png" />
                    <p>
                        Øverst til høyre i kartet finnes det ulike verktøyknapper, se bildet til høyre. 
                        I verktøylinjen kan du gjøre følgende:
                    </p>
                    <ul>
                        <li>Velge bakgrunnskart - Velge blant et sett med ulike bakgrunnskart</li> 
                        <li>Skru av/på kartlag - Skru av og på ulikt innhold, slik som kommuneplaner eller historisk øk. Klikk på "..." for å endre gjennomsiktigheten til kartlaget.</li>
                        <li>Vise tegnforklaring - Se hva symbolene i kartet betyr</li>
                        <li>Måle avstand - Klikk i kartet for å tegne en linje, dobbelt-klikk for å avslutte, og velg hvilken måleenhet du vil se</li>
                        <li>Måle areal - Klikk i kartet for å tegne et område, dobbelt-klikk for å avslutte, og velg hvilken måleenhet du vil se</li>
                    </ul>
                </div>
                <div className="content-section">
                    <div className="section-title">Integrasjon i andre systemer</div>
                    <p>
                        All funksjonalitet i GeoEiendom er også tilgjengelig som et programmeringsgrensesnitt (API),
                        for de som har behov for å integrere matrikkel- og grunnbokinformasjon i andre systemer.
                        Ta kontakt med Geodata AS for tilgang til dette. Dokumentasjon av API'et finnes&nbsp;
                        <a href={`/api-docs/index-html`} target="_blank">her</a>.
                    </p>
                </div>
            </div>
        </div>
        )

    }
}

export default withTranslation('common')(About)